const SupportedLanguage = {
  veluxMulti: {
    'bg-BG': 'bg',
    'cs-CZ': 'cs',
    'da-DK': 'da',
    'de-AT': 'de-AT',
    'de-CH': 'de-CH',
    'de-DE': 'de',
    'en-GB': 'en-GB',
    'en-US': 'en-US',
    'es-ES': 'es-ES',
    'es-US': 'es-US',
    'fi-FI': 'fi',
    'fr-BE': 'fr-BE',
    'fr-CH': 'fr-CH',
    'fr-FR': 'fr',
    'hr-HR': 'hr',
    'hu-HU': 'hu',
    'it-IT': 'it',
    'it-CH': 'it-CH',
    'ja-JP': 'ja',
    'nl-BE': 'nl-BE',
    'nl-NL': 'nl',
    'no-NO': 'no',
    'pl-PL': 'pl',
    'pt-PT': 'pt',
    'ro-RO': 'ro',
    'ru-RU': 'ru',
    'sk-SK': 'sk',
    'sl-SI': 'sl',
    'sr-Latn': 'sr-Latn',
    'sv-SE': 'sv-SE',
    'tr-TR': 'tr',
    'uk-UA': 'uk',
  },
  single: {
    'bg-BG': 'bg',
    'cs-CZ': 'cs',
    'da-DK': 'da',
    'de-AT': 'de-AT',
    'de-CH': 'de-CH',
    'de-DE': 'de',
    'en-GB': 'en-GB',
    'en-US': 'en-GB',
    'es-ES': 'es',
    'es-US': 'es',
    'fi-FI': 'fi',
    'fr-BE': 'fr-BE',
    'fr-CH': 'fr-CH',
    'fr-FR': 'fr',
    'hr-HR': 'hr',
    'hu-HU': 'hu',
    'it-IT': 'it',
    'it-CH': 'it',
    'ja-JP': 'ja',
    'nl-BE': 'nl-BE',
    'nl-NL': 'nl',
    'no-NO': 'no',
    'pl-PL': 'pl',
    'pt-PT': 'pt',
    'ro-RO': 'ro',
    'ru-RU': 'ru',
    'sk-SK': 'sk',
    'sl-SI': 'sl',
    'sr-Latn': 'sr-Latn',
    'sv-SE': 'sv',
    'tr-TR': 'tr',
    'uk-UA': 'uk',
  },
};

const BackupLanguage = {
  veluxMulti: {
    bg: 'bg',
    cs: 'cs',
    da: 'da',
    de: 'de',
    en: 'en-GB',
    es: 'es',
    fi: 'fi',
    fr: 'fr',
    hr: 'hr',
    hu: 'hu',
    it: 'it',
    ja: 'ja',
    nl: 'nl',
    no: 'no',
    pl: 'pl',
    pt: 'pt',
    ro: 'ro',
    ru: 'ru',
    sk: 'sk',
    sl: 'sl',
    sr: 'sr-Latn',
    sv: 'sv',
    tr: 'tr',
    uk: 'uk',
  },
  single: {
    bg: 'bg',
    cs: 'cs',
    da: 'da',
    de: 'de',
    en: 'en-GB',
    es: 'es',
    fi: 'fi',
    fr: 'fr',
    hr: 'hr',
    hu: 'hu',
    it: 'it',
    ja: 'ja',
    nl: 'nl',
    no: 'no',
    pl: 'pl',
    pt: 'pt',
    ro: 'ro',
    ru: 'ru',
    sk: 'sk',
    sl: 'sl',
    sr: 'sr-Latn',
    sv: 'sv',
    tr: 'tr',
    uk: 'uk',
  },
};

const DefaultLanguage = {
  single: 'en-GB',
  multi: 'en-GB',
};

export { SupportedLanguage, BackupLanguage, DefaultLanguage };
